import { render, staticRenderFns } from "./MealTemplateSummary.vue?vue&type=template&id=4ac6b212&"
import script from "./MealTemplateSummary.vue?vue&type=script&lang=js&"
export * from "./MealTemplateSummary.vue?vue&type=script&lang=js&"
import style0 from "./MealTemplateSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports